/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import ContactPhotoSchema from './ContactPhotoSchema.mjs'

const ContactSchema = new Schema({
  description: {
    type: 'string',
    maxLength: 100
  },
  email: {
    type: 'string',
    format: 'email',
    maxLength: 100
  },
  enabled: {
    type: 'boolean',
    required: true
  },
  mobile: {
    type: 'string',
    maxLength: 15,
    pattern: '^(\\+?[0-9]+\\.)?[0-9]+$'
  },
  name: {
    type: 'string',
    maxLength: 100,
    required: true
  },
  phone: {
    type: 'string',
    maxLength: 15,
    pattern: '^(\\+?[0-9]+\\.)?[0-9]+$'
  },
  photo: {
    type: ContactPhotoSchema
  },
  position: {
    type: 'number',
    required: true
  }
})

export default ContactSchema
